/**
 * @generated SignedSource<<3559a01d74965c9ff2c8b0dc56ab98f2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_homeBroadcastWidget_Widget$data = {
  readonly jira: {
    readonly allJiraUserBroadcastMessages: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly shouldDisplay: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  };
  readonly " $fragmentType": "main_homeBroadcastWidget_Widget";
};
export type main_homeBroadcastWidget_Widget$key = {
  readonly " $data"?: main_homeBroadcastWidget_Widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_homeBroadcastWidget_Widget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "main_homeBroadcastWidget_Widget",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              }
            ],
            "concreteType": "JiraUserBroadcastMessageConnection",
            "kind": "LinkedField",
            "name": "allJiraUserBroadcastMessages",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraUserBroadcastMessageEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraUserBroadcastMessage",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "shouldDisplay"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};

(node as any).hash = "940d7a80f47673c6e7419ac366f0f8c6";

export default node;
